import { connect, useStore, Provider as ReduxProvider, useSelector } from 'react-redux';
import { renderToStaticMarkup } from 'react-dom/server';
import { IonItem, IonIcon, IonSpinner } from '@ionic/react';
import { cloudDownload } from 'ionicons/icons';

import ProjectActions from 'actions/ProjectActions';
import { cutSheetPages } from 'helpers/report';
import { productTypesSelector } from 'selectors/productSelector';
import { withOnline } from 'components/helpers/online-helper';
import Report from './Report';

const mapStateToProps = () => ({});
function mapDispatchToProps(dispatch, _props) {
  return {
    downloadReport: ({id, markup, cut_sheet_pages, callback, errorCallback}) => {
      return dispatch(ProjectActions.downloadReport({
        id, markup, cut_sheet_pages, callback, errorCallback
      }));
    },
  }
}

function withReduxConnect(Component) {
  return connect(mapStateToProps, mapDispatchToProps)(Component);
}

class ReportButton extends React.Component {
  state = {loading: false}

  download = (e) => {
    const {online, project, productTypes, ReduxPassthrough} = this.props;
    if (!online) {
      return alert("You must be online to download a report.");
    }
    const markup = renderToStaticMarkup(
      <ReduxPassthrough>
        <Report project={project}/>
      </ReduxPassthrough>
    );
    const cut_sheet_pages = cutSheetPages(project, productTypes);
    this.setState({loading: true});
    this.props.downloadReport({
      id: project.id,
      markup,
      cut_sheet_pages,
      callback: this.openToPdf,
      errorCallback: this.reportGenerationFailed,
    });
  }

  openToPdf = ({url}) => {
    window.location.href = url;
    this.setState({loading: false});
  }

  reportGenerationFailed = (_error) => {
    this.setState({reportError: "Report Generation Failed"});
  }

  render() {
    if (!this.props.online) return null;
    return (
      <IonItem iconLeft onClick={this.download} button detail={false}>
        {this.state.loading ? (
          <IonSpinner name="lines-sharp-small" slot="start"/>
        ) : (
          <IonIcon icon={cloudDownload} slot="start"/>
        )}
        Download Report (pdf)
      </IonItem>
    );
  }
}

function withReduxProvider(Component) {
  return function ReduxStoreWrapper(props) {
    const store = useStore();
    const productTypes = useSelector(productTypesSelector);
    function ReduxPassthrough({children}) {
      return <ReduxProvider store={store}>{children}</ReduxProvider>
    };

    return <Component {...props} productTypes={productTypes} ReduxPassthrough={ReduxPassthrough}/>;
  }
}

export default withReduxProvider(withReduxConnect(withOnline(ReportButton)));
